import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { Button, Divider, Typography } from '@mui/material';
import { UBItem } from './UBItemMock';
import { Link } from "react-router-dom";

export const UBMetric = ({ title, events, compact = false }) => {
    return (
        <UBItem styles={{}}>
            <Button
                component={Link}
                to={{ pathname: `/unionbankmock/realtime` }}
                sx={{ color: 'white', display: 'block', textTransform: 'none' }}
            >
                <Typography onClick={() => { }} variant="h5" fontWeight="bold" align="left">{title}</Typography>
            </Button>

            <Divider />

            <Grid container spacing={2} p={2} justifyContent="center" alignItems="center">
                {events.map(event => {
                    return (
                        <>
                            {event?.event_label &&
                                <Grid sm={5} md={4}>
                                    <Typography align="left">{event?.event_label}</Typography>
                                </Grid>
                            }

                            {event.metrics.map(metric => {
                                return (
                                    <>
                                        <Grid md={!event?.event_label && !compact ? 8 : 2}>
                                            <Typography align="right">{metric.label}:</Typography>
                                        </Grid>
                                        <Grid md={!event?.event_label && !compact ? 4 : 2}>
                                            <Typography align="right">{metric.value}</Typography>
                                        </Grid>
                                    </>
                                )
                            })}
                        </>
                    );
                })}
            </Grid>
        </UBItem>
    );
}